module.exports = __webpack_public_path__ + "static/media/2-1.fd4c8031.mp3";